(() => {
  const explorer = document.querySelector('[data-sport-activity-explorer]');
  if (!explorer) return;

  const triggers = [...explorer.querySelectorAll('[data-activity-trigger]')];
  const reveal = explorer.querySelector('[data-activity-reveal]');
  const panels = [...explorer.querySelectorAll('[data-activity-panel]')];
  let active = '';

  const setActive = key => {
    const same = active === key;
    active = same ? '' : key;

    triggers.forEach(button => {
      const isActive = !!active && button.dataset.activityTrigger === active;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    panels.forEach(panel => {
      const isActive = !!active && panel.dataset.activityPanel === active;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    reveal?.classList.toggle('is-open', !!active);

    if (active && reveal) {
      window.setTimeout(() => {
        const rect = reveal.getBoundingClientRect();
        if (rect.bottom > window.innerHeight + 100) {
          reveal.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
        }
      }, 180);
    }
  };

  triggers.forEach(button => button.addEventListener('click', () => setActive(button.dataset.activityTrigger)));
})();
